import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {

	componentDidMount() {
		let publicUrl = process.env.PUBLIC_URL + '/'
		const minscript = document.createElement("script");
		minscript.async = true;
		minscript.src = publicUrl + "assets/js/main.js";

		document.body.appendChild(minscript);
	}

	render() {

		let publicUrl = process.env.PUBLIC_URL + '/'

		return (
			<footer className="footer-area">
				<div className="footer-top">
					<div className="section-title text-center">
						<h4 className="text-white">Restaurant Hours</h4>
					</div>
					<div className="container text-center">
						<div className="row justify-content-center">
							<div className="col-md-3">
								<div class="op-hrs">
									Monday : 10:30 - 22:00 
								</div>
							</div>
							<div className="col-md-3">
								<div class="op-hrs">
									Tuesday : 10:30 - 22:00 
								</div>
							</div>
							<div className="col-md-3">
								<div class="op-hrs">
									Wednesday : 10:30 - 22:00     
								</div>
							</div>
							<div className="col-md-3">
								<div class="op-hrs">
									Thursday : 10:30 - 22:00 
								</div>
							</div>
							<div className="col-md-3">
								<div class="op-hrs">
									Friday : 10:30 - 22:00 
								</div>
							</div>
							<div className="col-md-3">
								<div class="op-hrs">
									Saturday : 12:00 - 22:00 
								</div>
							</div>
							<div className="col-md-3">
								<div class="op-hrs">
									Sunday :  Closed
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="footer-middle">
					<div className="container">
						<div className="row">
							<div className="col-lg-4 col-md-4">
								<div className="widget widget_newsfeed">
									<h5 className="widget-title">Useful Links</h5>
									<ul className="go-top">
										<li><Link to="/blog"><i class="fa-solid fa-arrow-right-to-line"></i> Home</Link></li>
										<li><Link to="/blog"><i class="fa-solid fa-arrow-right-to-line"></i> About Us</Link></li>
										<li><Link to="/blog"><i class="fa-solid fa-arrow-right-to-line"></i> Menu</Link></li>
									</ul>
								</div>
							</div>
							<div className="col-lg-4 col-md-4">
								<div className="widget widget_newsfeed">
									<h5 className="widget-title">Useful Links</h5>
									<ul className="go-top">
										<li><Link to="/blog"><i class="fa-solid fa-arrow-right-to-line"></i> Reservation</Link></li>
										<li><Link to="/blog"><i class="fa-solid fa-arrow-right-to-line"></i> Gallery</Link></li>
										<li><Link to="/blog"><i class="fa-solid fa-arrow-right-to-line"></i> Contact Us</Link></li>
									</ul>
								</div>
							</div>
							<div className="col-lg-4 col-md-4">
								<div className="widget widget_about">
									<h5 className="widget-title">Contact Us</h5>
									<div className="details">
										<p><i class="fas fa-map-marker-alt" aria-hidden="true"></i> Kaupinkalliontie 7, 02100 Espoo</p>
										<p><i class="fas fa-phone-volume" aria-hidden="true"></i> 09463400</p>
										<p><i class="fas fa-envelope" aria-hidden="true"></i> info@mountnepal.fi</p>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-12 col-md-12">
								<img src={publicUrl+"assets/img/row.png"} alt="img" />
							</div>
						</div>
					</div>
				</div>
				<div className="footer-bottom">
					<div className="container">
						<div className="row">
							<div className="col-md-12 text-center">
								<p>©2024, Copy Right By Softa Technologies OY Ltd. All Rights Reserved</p>
							</div>
						</div>
					</div>
				</div>
			</footer>

		)
	}
}


export default Footer